import { visit } from 'unist-util-visit';
/**
 * LLMs often wrap @dataset:… (and similar dot-separated entity paths) in Markdown
 * inline code (`…`), since qualified names like `db.schema.table` look like code
 * identifiers to them. That produces mdast `inlineCode` nodes, which the mention
 * plugin does not visit (it only splits `text` nodes).
 * This plugin rewrites an inline-code node whose content is purely an entity mention
 * into a `text` node so mentionPlugin + MentionComponent render it as a badge.
 */ const INLINE_ENTITY_MENTION = /^@(pipeline|gem|dataset|file):/i;
/** Must stay in sync with Copilot `escapeMdUnderScore` / `unescapeMdUnderScore` (ChatMarkdown). */ function unescapeMdUnderScore(text) {
    return text.replace(/\\_/g, '_');
}
export function unwrapInlineMentionCodePlugin() {
    return (tree)=>{
        const toReplace = [];
        visit(tree, 'inlineCode', (node, index, parent)=>{
            if (parent === undefined || index === null || index === undefined) return;
            const value = node.value.trim();
            if (!INLINE_ENTITY_MENTION.test(value)) return;
            // ChatMarkdown escapes `_` → `\_` on the whole message; the `code` renderer unescapes.
            // After unwrap we emit `text`, so undo that escape here or badges show `top\_foo\_bar`.
            toReplace.push({
                parent,
                index,
                value: unescapeMdUnderScore(value)
            });
        });
        for (const { parent, index, value } of toReplace.sort((a, b)=>{
            if (a.parent === b.parent) return b.index - a.index;
            return 0;
        })){
            parent.children.splice(index, 1, {
                type: 'text',
                value
            });
        }
    };
}
